<div *ngIf="show" class="spinner-grow spinner-grow-sm">
  <span class="sr-only">Loading...</span>
</div>
